import { useStore } from '@nanostores/react'
import { isCartOpen, cartData } from '@stores/cartStore'
import { checkoutData } from '@stores/checkoutStore'
import va from '@vercel/analytics'
import {
    updateCart,
    updateCartDiscountCodes,
    updateCartNote,
    updateCartAttributes,
    updateCheckoutAttributes,
    getCart,
} from '@api/shopify'

import { chord } from '@api/chord.js'

import { addUrlParameter, deepEqual, getCookie } from '@utils/utils'

export const handleQuantityChange = (cartId, id, quantity, type) => {
    if (quantity === -1 || quantity === '-1') {
        return
    }

    if (type === 'increment') {
        quantity = parseInt(quantity) + 1
    } else if (type === 'decrement') {
        quantity = parseInt(quantity) - 1
    }

    let lines = {
        id: id,
        quantity: quantity,
    }

    updateCart(cartId, lines).then((updateCartData) => {
        let cartLines = updateCartData.body.cartLinesUpdate.cart.lines.edges
        let cartCost = updateCartData.body.cartLinesUpdate.cart.cost
        let discountCodes =
            updateCartData.body.cartLinesUpdate.cart.discountCodes

        let hasGiftCardInCart = cartLines?.some(
            (line) =>
                line.node?.merchandise?.id ===
                'gid://shopify/ProductVariant/41447180697662'
        )

        let cartObj = {
            ...cartData.get(),
            lines: cartLines,
            cost: cartCost,
            discountCodes: discountCodes,
            freeGiftCardAdded: hasGiftCardInCart,
        }
        if (cartLines.length === 0) {
            let discounts = document.getElementsByClassName('remove-discount')
            if (discounts.length > 0) {
                for (let i = 0; i < discounts.length; i++) {
                    discounts[i].click()
                }
            }

            cartObj = {
                ...cartData.get(),
                lines: [],
                cost: {},
                discountCodes: [],
            }
        }

        cartData.set(cartObj)
    })
}

export const handleRemoveDiscount = (
    cartId,
    currentDiscountCodes,
    discountCode
) => {
    if (discountCode) {
        let newDiscountCodes = currentDiscountCodes.filter((discount) => {
            return discount.code !== discountCode
        })

        updateCartDiscountCodes(cartId, newDiscountCodes).then((data) => {
            // // console.log discount remove data', data)
            let cartCost = data.body.cartDiscountCodesUpdate.cart.cost
            let cartLines = data.body.cartDiscountCodesUpdate.cart.lines.edges
            let discountCodes =
                data.body.cartDiscountCodesUpdate.cart.discountCodes

            let cartObj = {
                ...cartData.get(),
                cost: cartCost,
                lines: cartLines,
                discountCodes: discountCodes,
            }

            chord.trackCouponRemoved({
                cartId: cartId.replace('gid://shopify/Cart/', ''),
                couponName: discountCode,
            })

            cartData.set(cartObj)
        })
    }
}

export const handleCheckout = (checkoutUrl) => {
    if (checkoutUrl) {
        let $cartData = cartData.get()

        // chord.trackCheckoutStarted({ checkout: $cartData })

        const cartLinesArray = $cartData?.lines.map((line) => {
            let item = line.node

            const str = line.node.merchandise.id
            const n = str.lastIndexOf('/')
            const lineItemId = str.substring(n + 1)

            let product = {
                item_name: item.merchandise.product.title,
                item_id: lineItemId,
                price: Number(item.cost.totalAmount.amount),
                item_category:
                    item.merchandise.product?.options[0]?.values[0] || '',
                item_category2:
                    item.merchandise.product?.options[1]?.values[0] || '',
                item_category3:
                    item.merchandise.product?.options[2]?.values[0] || '',
                item_variant: lineItemId,
                quantity: item.quantity,
            }

            return product
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'dl_begin_checkout',
            ecommerce: {
                items: cartLinesArray,
                value: Number($cartData?.cost?.totalAmount?.amount),
            },
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'GA4_begin_checkout',
            currency: 'USD',
            ecommerce: {
                items: cartLinesArray,
                value: Number($cartData?.cost?.totalAmount?.amount),
            },
        })

        va.track('begin_checkout', {
            cart_id: $cartData?.id,
            cart_items: cartLinesArray,
            cart_total: $cartData?.cost?.totalAmount?.amount,
        })

        nostojs(api => {
            api.defaultSession()
              .viewCart()
              .setPlacements(['cart-related'])
              .load()
              .then(data => {
                console.log('data start checkout', data);
              })
          });


        const goToCheckout = () => {
            window.location = checkoutUrl
        }

        setTimeout(() => {
            goToCheckout()
        }, 1000)
    }
}

export const manageDiscounts = (cartId, discountCode) => {
    chord.trackCouponEntered({
        cartId: cartId.replace('gid://shopify/Cart/', ''),
        couponName: discountCode,
    })

    return new Promise((resolve) => {
        updateCartDiscountCodes(cartId, discountCode)
            .then((data) => {
                let discountCodes =
                    data.body.cartDiscountCodesUpdate.cart.discountCodes

                if (!discountCodes[0]?.applicable) {
                    chord.trackCouponDenied({
                        cartId: cartId.replace('gid://shopify/Cart/', ''),
                        couponName: discountCode,
                    })

                    resolve(
                        `We're sorry, ${discountCode} is not a valid discount code`
                    )
                } else {
                    let cartCost = data.body.cartDiscountCodesUpdate.cart.cost
                    let cartLines =
                        data.body.cartDiscountCodesUpdate.cart.lines.edges

                    let cartObj = {
                        ...cartData.get(),
                        cost: cartCost,
                        lines: cartLines,
                        discountCodes: discountCodes,
                    }
                    cartData.set(cartObj)

                    chord.trackCouponApplied({
                        cartId: cartId.replace('gid://shopify/Cart/', ''),
                        couponName: discountCode,
                    })

                    resolve('')
                }
            })
            .catch((error) => {
                // Handle any errors that occurred during the asynchronous operations
                resolve('An error occurred while applying the discount')
            })
    })
}

export const handleRemoveBundle = (cartId, id, bundle_id, bundle_size) => {
    let $cartData = cartData.get()
    let lines
    let cartLines = $cartData.lines
    console.log(
        'handleRemoveBundle',
        cartId,
        id,
        bundle_id,
        bundle_size,
        cartLines
    )
    let filteredLines = cartLines.map((line) => {
        // console.log("line: ", line);
        let bundle_info =
            line.node.attributes[0]?.key === '_bundle_info'
                ? JSON.parse(line.node.attributes[0].value)
                : null
        if (
            bundle_info &&
            bundle_info.bundle_id.toString() === bundle_id.toString() &&
            bundle_info.bundle_size === bundle_size
        ) {
            return {
                quantity: 0,
                id: line.node.id,
            }
        }
    })
    filteredLines = filteredLines.filter((line) => {
        if (line !== undefined) {
            return line
        }
    })
    // console.log("-----filteredLines", filteredLines);
    updateCart(cartId, filteredLines).then((updateCartData) => {
        // console.log('updateCartData after Bundle remove', updateCartData)
        let cartLines = updateCartData.body.cartLinesUpdate.cart.lines.edges
        let cartCost = updateCartData.body.cartLinesUpdate.cart.cost
        let discountCodes =
            updateCartData.body.cartLinesUpdate.cart.discountCodes
        // console.log('cartLines in item Removed, cartCost', cartLines, cartCost)

        let cartObj = {
            ...cartData.get(),
            lines: cartLines,
            cost: cartCost,
            discountCodes: discountCodes,
        }

        cartData.set(cartObj)
    })
}

export const handleRemoveItem = (
    cartId,
    id,
    quantity,
    hasEmbroidery,
    variantId
) => {
    let $cartData = cartData.get()
    let lines
    let cartLines = $cartData.lines

    //

    let itemRemovedId = variantId?.split('/').pop()

    let freeGiftCardRemoved = false

    if (itemRemovedId === 'gid://shopify/ProductVariant/41447180697662') {
        freeGiftCardRemoved = true
    }

    if (hasEmbroidery) {
        let matchingEmbroideryOption = cartLines.find((line) => {
            return (
                line.node.merchandise.product.title === 'Embroidery Option' &&
                line.node.attributes[0].value.toString() ===
                    itemRemovedId.toString()
            )
        })

        let embroideryOptionId = matchingEmbroideryOption?.node?.id
        let matchingEmbroideryOptionId =
            matchingEmbroideryOption?.node?.attributes[0]?.value
        let embroideryOptionQuantity = matchingEmbroideryOption?.node?.quantity

        if (
            matchingEmbroideryOptionId.toString() === itemRemovedId.toString()
        ) {
            lines = [
                {
                    id: embroideryOptionId,
                    quantity: embroideryOptionQuantity - quantity,
                },
                {
                    id: id,
                    quantity: 0,
                },
            ]
        } else {
            lines = {
                id: id,
                quantity: 0,
            }
        }
    } else {
        lines = {
            id: id,
            quantity: 0,
        }
    }

    if (cartLines && cartLines.length > 0) {
        let items = cartLines
        let itemRemoved = items.filter((item) => {
            return item.node.id === id
        })

        let gtmItems = itemRemoved.map((item) => {
            let itemId = item.node.merchandise.id
            itemId = itemId.split('/').pop()
            let product = {
                item_name: item?.node?.merchandise?.product?.title,
                item_id: itemId ? String(itemId) : '',
                price: Number(item?.node?.cost?.totalAmount?.amount) || '',
                item_category:
                    item.node.merchandise.product?.options[0]?.values[0] || '',
                item_category2:
                    item.node.merchandise.product?.options[1]?.values[0] || '',
                item_category3:
                    item.node.merchandise.product?.options[2]?.values[0] || '',
                item_variant: String(item?.node?.merchandise?.title),
                quantity: item?.node?.quantity || 1,
            }

            return product
        })

        chord.trackProductRemoved({
            cart: $cartData,
            lineItem: itemRemoved?.[0]?.node,
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'dl_remove_from_cart',
            ecommerce: {
                items: gtmItems,
            },
        })

        dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'GA4_remove_from_cart',
            ecommerce: {
                items: gtmItems,
            },
        })

        const nostoCartLines = cartLines.map((line) => {
            console.log('line in nostoCartLines', line)
            const productId = line.node.merchandise.product.id
            const productIdNumber = productId.split('/').pop()
            const skuId = line.node.merchandise.id
            const skuIdNumber = skuId.split('/').pop()
            return {
                name: line.node.merchandise.product.title,
                price_currency_code: 'USD',
                product_id: productIdNumber,
                quantity: line.node.quantity,
                sku_id: skuIdNumber,
                unit_price: Number(line.node.cost.totalAmount.amount),
            }
        })

        nostojs((api) => {
            api.defaultSession()
                .setCart({
                    items: nostoCartLines,
                })
                .viewCart()
                .update()
                .then((response) => {
                    console.log('Nosto cart update response new cart:', response);
                    // Handle the response here
                    return response;
                })
                .catch((error) => {
                    console.error('Nosto cart update error:', error);
                });
        })
    }

    updateCart(cartId, lines).then((updateCartData) => {
        let cartLines = updateCartData.body.cartLinesUpdate.cart.lines.edges
        let cartCost = updateCartData.body.cartLinesUpdate.cart.cost
        let discountCodes =
            updateCartData.body.cartLinesUpdate.cart.discountCodes

        // console.log('cartLines in updateCart in handleRemoveItem', cartLines)

        const freeGiftCardLine = cartLines.find((line) => {
            return line.node?.merchandise?.product?.sku === 'E-GIFT-CARD-20'
        })

        // console.log('freeGiftCardLine', freeGiftCardLine)

        let cartObj = {
            ...cartData.get(),
            lines: cartLines,
            cost: cartCost,
            discountCodes: discountCodes,
            freeGiftCardAdded: freeGiftCardLine ? true : false,
        }

        cartData.set(cartObj)

        // update the cart object if there are no more items in the cart
        if (cartLines.length === 0) {
            let discounts = document.getElementsByClassName('remove-discount')
            if (discounts.length > 0) {
                for (let i = 0; i < discounts.length; i++) {
                    discounts[i].click()
                }
            }

            let cartObj = {
                ...cartData.get(),
                lines: [],
                cost: {},
                discountCodes: [],
                freeGiftCardAdded: false,
            }

            cartData.set(cartObj)
        }

        if (cartLines.length === 1 && cartData.get().freeGiftCardAdded) {
            let cartObj = {
                ...cartData.get(),
                lines: [],
                cost: {},
                discountCodes: [],
                freeGiftCardAdded: false,
            }
            cartData.set(cartObj)
        }

        const nostoCartLines = cartLines.map((line) => {
            console.log('line in nostoCartLines', line)
            const productId = line.node.merchandise.product.id
            const productIdNumber = productId.split('/').pop()
            const skuId = line.node.merchandise.id
            const skuIdNumber = skuId.split('/').pop()
            return {
                name: line.node.merchandise.product.title,
                price_currency_code: 'USD',
                product_id: productIdNumber,
                quantity: line.node.quantity,
                sku_id: skuIdNumber,
                unit_price: Number(line.node.cost.totalAmount.amount),
            }
        })

        nostojs((api) => {
            api.defaultSession()
                .setCart({
                    items: nostoCartLines,
                })
                .viewCart()
                .update()
                .then((response) => {
                    console.log('Nosto cart update response new cart:', response);
                    // Handle the response here
                    return response;
                })
                .catch((error) => {
                    console.error('Nosto cart update error:', error);
                });
        })
    })
}

export const handleNoteSubmit = (cartId, giftNote) => {
    let encodedGiftNote = encodeURIComponent(giftNote)
    updateCartNote(cartId, giftNote).then((data) => {
        let cartNote = data.body.cartNoteUpdate.cart.note
        let checkoutUrl = cartData.get().checkoutUrl
        let newUrl = ''

        if (checkoutUrl) {
            newUrl = addUrlParameter(
                checkoutUrl,
                'giftNote',
                encodedGiftNote,
                true
            )

            newUrl = addUrlParameter(newUrl, 'giftWrap', 'YES', true)
        }
        let cartObj = {
            ...cartData.get(),
            giftNote: cartNote,
            giftWrap: true,
            checkoutUrl: newUrl,
        }

        cartData.set(cartObj)
    })

    const attributes = [
        {
            key: 'giftWrap',
            value: 'YES',
        },
    ]
}

export const handleCheckoutAttributes = (cartId, giftWrap, giftNote) => {
    let attributes = [
        {
            key: 'gift_wrap',
            value: 'YES',
        },
        {
            key: 'gift_note',
            value: giftNote,
        },
    ]

    const input = {
        customAttributes: attributes,
        note: 'gift_note: ' + giftNote,
    }

    updateCheckoutAttributes(cartId, input).then((data) => {
        let cartObj = {
            ...cartData.get(),
            checkoutAttributes:
                data?.body?.checkoutAttributesUpdate?.checkout
                    ?.customAttributes || [],
        }

        cartData.set(cartObj)
    })
}

function checkCorrectValue(value) {
    // Check if the anonymousId is a non-empty string
    if (typeof value === 'string' && value.trim() !== '') {
        return true
    }

    return false
}

/**
 * Used by Chord. Persist tracking parameters as cart attributes.
 */
export const updateCartTrackingAttributes = async (cartId, giftAttr = null) => {
    const cje = getCookie('cje') || 'cje_cookie'
    try {
        //
        let input
        if (giftAttr) {
            // ?.anonymousId?.()) &&
            // 		checkCorrectValue(getCookie("_ga")?.substring(6)),
            // 	checkCorrectValue(window.analytics?.user?.()?.anonymousId?.()),
            // 	checkCorrectValue(getCookie("_ga")?.substring(6))
            // );
            if (
                checkCorrectValue(
                    window.analytics?.user?.()?.anonymousId?.()
                ) &&
                checkCorrectValue(getCookie('_ga')?.substring(6))
            ) {
                //
                input = [
                    {
                        key: 'segmentId',
                        value: window.analytics?.user?.()?.anonymousId?.(),
                    },
                    {
                        key: 'googleClientId',
                        value: getCookie('_ga')?.substring(6),
                    },
                    {
                        key: 'cjevent',
                        value: cje ? cje : '',
                    },
                    ...giftAttr,
                ]
            } else {
                //
                input = [...giftAttr, { key: 'cjevent', value: cje ? cje : '' }]
            }
        } else {
            input = [
                {
                    key: 'segmentId',
                    value: window.analytics?.user?.()?.anonymousId?.(),
                },
                {
                    key: 'googleClientId',
                    value: getCookie('_ga')?.substring(6),
                },
                {
                    key: 'cjevent',
                    value: cje ? cje : '',
                },
            ]
        }

        // console.log('input in updateCartTrackingAttributes', input)
        return updateCartAttributes(cartId, input)
    } catch (error) {
        console.error('Error updating cart tracking attributes', error)
        return
    }
}
